// Adds the checked add-on product to the cart before Dawn's product form submits,
// so the cart drawer opens with both items in it.
(function () {
  if (window.__tinsAddonBound) return;
  window.__tinsAddonBound = true;

  document.addEventListener(
    'submit',
    function (evt) {
      var form = evt.target;
      if (!form || !form.closest || !form.closest('product-form')) return;
      if (form.dataset.tinsAddonDone === 'true') {
        delete form.dataset.tinsAddonDone;
        return;
      }
      var section = form.closest('section, .shopify-section');
      var box = section && section.querySelector('.tins-addon__input:checked');
      if (!box) return;

      evt.preventDefault();
      evt.stopPropagation();
      var submitter = evt.submitter;

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(box.dataset.variantId), quantity: 1 }] }),
      })
        .catch(function () {})
        .finally(function () {
          form.dataset.tinsAddonDone = 'true';
          if (form.requestSubmit) {
            form.requestSubmit(submitter && submitter.form === form ? submitter : undefined);
          } else {
            form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
          }
        });
    },
    true
  );
})();
